/* Brand carousel — hero for All Beauty Brands.
   Ported from the approved Cloudflare preview (hero-b.html), 10 Sep.

   TRUE CONTINUOUS LOOP
   --------------------
   Wrapping by scrolling back to 0 at the end reads as a rewind: the whole rail
   visibly runs backwards past every slide. A real loop never changes direction.
   So the slide set is cloned once at init. Next always travels FORWARD; when it
   reaches the start of the clone set the rail is silently rebased back by
   exactly one set width. The clones are pixel-identical to the originals at
   that position, so the rebase cannot be seen.

   The rebase must be an exact multiple of the slide pitch or it shows up as a
   jitter — hence absolute scrollTo positions off an integer page counter, never
   accumulated scrollBy calls.
*/
(function () {
  'use strict';

  var GAP = 16;

  function init(root) {
    if (!root || root.dataset.bcReady === '1') return;

    var rail  = root.querySelector('[data-bc-rail]');
    var pages = root.querySelector('[data-bc-pages]');
    var prevB = root.querySelector('[data-bc-prev]');
    var nextB = root.querySelector('[data-bc-next]');
    if (!rail || !pages) return;

    var originals = Array.prototype.slice.call(rail.querySelectorAll('.bc__slide'));
    var N = originals.length;
    if (N === 0) return;

    root.dataset.bcReady = '1';

    // How many fit across right now. Two above the mobile breakpoint, one below.
    function per() { return window.matchMedia('(max-width: 899px)').matches ? 1 : 2; }
    var PER = per();
    var nPages = Math.ceil(N / PER);

    // A single slide is its own page and needs no rail behaviour at all.
    if (N <= PER) { pages.remove(); if (prevB) prevB.remove(); if (nextB) nextB.remove(); return; }

    // Clone the set once — decorative only, and out of the tab order.
    originals.forEach(function (s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.dataset.clone = '1';
      Array.prototype.forEach.call(c.querySelectorAll('a,button'), function (a) { a.tabIndex = -1; });
      rail.appendChild(c);
    });

    function pitch()    { return originals[0].getBoundingClientRect().width + GAP; }
    function pageStep() { return pitch() * PER; }
    function setWidth() { return pitch() * N; }      // === nPages * pageStep()

    var cur = 0;                                      // logical page, 0..nPages-1
    var settle = null;

    function buildDots() {
      pages.innerHTML = '';
      for (var n = 0; n < nPages; n++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide group ' + (n + 1));
        (function (i) { b.addEventListener('click', function () { goPage(i); }); })(n);
        pages.appendChild(b);
      }
    }
    function mark(n) {
      Array.prototype.forEach.call(pages.children, function (d, k) {
        d.setAttribute('aria-current', k === n ? 'true' : 'false');
      });
    }
    /* Light the bar from the click, not from the scroll event: a smooth scroll
       takes ~400ms to settle, so waiting on it makes the indicator lag. */
    function afterSettle(fn) { clearTimeout(settle); settle = setTimeout(fn, 760); }
    function jump(px)  { rail.scrollTo({ left: px, behavior: 'instant' }); }
    function glide(px) { rail.scrollTo({ left: px, behavior: 'smooth' }); }

    function next() {
      glide((cur + 1) * pageStep());                 // always forward
      cur = cur + 1;
      mark(cur % nPages);
      if (cur >= nPages) afterSettle(function () { jump(0); cur = 0; });
    }
    function prev() {
      if (cur === 0) { jump(setWidth()); cur = nPages; }   // rebase forward first
      glide((cur - 1) * pageStep());
      cur = cur - 1;
      mark(cur % nPages);
    }
    function goPage(n) {
      if (cur >= nPages) { jump(0); cur = 0; }
      glide(n * pageStep()); cur = n; mark(n);
    }

    if (nextB) nextB.addEventListener('click', next);
    if (prevB) prevB.addEventListener('click', prev);

    // Free dragging: keep the indicator honest and rebase out of the clone set.
    var t;
    rail.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var x = rail.scrollLeft;
        if (x >= setWidth() - 1) { jump(x - setWidth()); x = rail.scrollLeft; }
        cur = Math.round(x / pageStep()) % nPages;
        mark(cur);
      }, 110);
    }, { passive: true });

    // Crossing the breakpoint changes how many fit, so the paging changes with it.
    window.addEventListener('resize', function () {
      var p = per();
      if (p !== PER) { PER = p; nPages = Math.ceil(N / PER); cur = 0; buildDots(); }
      jump(cur * pageStep());
      mark(cur % nPages);
    }, { passive: true });

    buildDots();
    mark(0);
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-bc]');
    Array.prototype.forEach.call(els, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
